<template>
	<div ref="knd-swiper" class="knd-swiper">

		<swiper
			:slidesPerView="1.2"
			:spaceBetween="30"
			:breakpoints='{
				"640": {
					"spaceBetween": 40,
					"slidesPerView": "auto"
				},
				"950": {
					"spaceBetween": 20,
					"slidesPerView": "auto"
				},

				"1040": {
					"spaceBetween": 60,
					"slidesPerView": "auto"
				}
			}'
			:centeredSlides="true" 
			:grabCursor="true"
			:pagination='{
				"dynamicBullets": true
			}'
			@swiper="onSwiper"
			@slideChange="onSlideChange"> 

			<swiper-slide 
				v-for="(slide, index) in swiperContent"
				:key="index +'-slide'"
				class="knd-swiper-slide">
				<div class="slide-scroll-wrapper">
					<!-- <img :src='require("@/assets/img/graverzij.png")' class="graverzij" /> -->
					<img :src='"https://pointer-dev.kro-ncrv.nl/" + slide.afbeelding[0].url' class="graverzij" />
					<div class="slider-tekst">
						<p class="slider-kop" v-html="getContent(slide.kop)"></p>
						<p v-html="getContent(slide.tekst)"></p>
					</div>
				</div>
			</swiper-slide>


		</swiper>

		<div class="swiper-gradient"></div>
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import SwiperCore, { Pagination, Lazy } from 'swiper';

	import "swiper/swiper-bundle.min.css";
	import './swiper.scss';

	SwiperCore.use([Pagination, Lazy]);

	export default {
		name: 'ProjectSwiper',
		props: [],
		components: {      
			Swiper,
			SwiperSlide,
		},
		computed: {
			// content() {
			// 	const storeContent = this.$store.state.content;
			// 	if (storeContent.intro) { //anders geeft hij foutmelding, store laadt later
			// 		return storeContent;
			// 	}
			// 	return null;
			// }
		},
		data() {
			return {
				swiperContent: this.$store.state.content.projectcarroussel,
				swiperOptions: {
					breakpoints: {
						// when window width is >= 480px
						480: {
							spaceBetween: 100
						}
					}
				}
			}
		},
		mounted() {
			this.goToSlide(2);
		},
		methods: {
			onSwiper(swiper) {
				this.swiper = swiper;
			},

			onSlideChange() {
				if (this.swiper) {
					// console.log("slide: ", this.swiper.activeIndex);
					// console.log(this.$store.state.content.projectcarroussel);
				}
			},

			goToSlide(index) {
				this.swiper.slideTo(index, 500);
			},

			getContent(content) {
				// if (this.$store.state.language === "nl") {
					return content.data;
				// }
				// else {
					// return content[label].data5891;	
				// }
			},

		},
		watch: {
			
		}
	}
</script>
